/**
 * Dashboard Box Definitions
 * Defines all available dashboard boxes that can be shown/hidden per role
 */

export interface DashboardBox {
  id: string;
  label: string;
  apiEndpoint: string;
  roles: string[]; // Roles that can access this box
  /**
   * Optional: list of actual app routes this widget links to.
   * Used for guiding admins to the corresponding page permissions.
   */
  linkedMenuPaths?: string[];
}

export const dashboardBoxes: DashboardBox[] = [
  {
    id: "users",
    label: "Benutzer:in",
    apiEndpoint: "user/get-user",
    roles: ["admin"],
    linkedMenuPaths: ["/users"],
  },
  {
    id: "category",
    label: "Kategorie",
    apiEndpoint: "category/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/service-category"],
  },
  {
    id: "company",
    label: "Gesellschaft",
    apiEndpoint: "company-profile/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/company"],
  },
  {
    id: "bulletin",
    label: "Schwarzes Brett",
    apiEndpoint: "post/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/post"],
  },
  {
    id: "contact",
    label: "Kontaktdaten",
    apiEndpoint: "contact/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/contact"],
  },
  {
    id: "news",
    label: "News",
    apiEndpoint: "news/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/news"],
  },
  {
    id: "warning",
    label: "Warnungen",
    apiEndpoint: "warning/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/warning"],
  },
  {
    id: "imprint",
    label: "Impressum",
    apiEndpoint: "imprint/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/imprint"],
  },
  {
    id: "privacy",
    label: "Privatsphäre",
    apiEndpoint: "privacy/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/privacy"],
  },
  {
    id: "subcategory",
    label: "Unterkategorie",
    apiEndpoint: "service/find-items",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/service-category-items"],
  },
  {
    id: "challenges",
    label: "Challenges",
    apiEndpoint: "challenges/find",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/challenges"],
  },
  {
    id: "redeem",
    label: "Münzen einlösen",
    apiEndpoint: "challenges/findData",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/redeem-coins"],
  },
  {
    id: "guides",
    label: "Guides",
    apiEndpoint: "guides/findGuides",
    roles: ["admin", "superadmin"],
    linkedMenuPaths: ["/guides"],
  },
];

/**
 * Get dashboard boxes for a specific role
 */
export const getDashboardBoxesForRole = (role: string): DashboardBox[] => {
  return dashboardBoxes.filter((box) => box.roles.includes(role));
};

/**
 * Get a single dashboard box by ID
 */
export const getDashboardBoxById = (id: string): DashboardBox | undefined => {
  return dashboardBoxes.find((box) => box.id === id);
};
